import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import {
  useClassName,
  useDOMElement,
  useWindowSize,
  useScrollDirection,
} from 'common/hooks';
import BookTicketsSheet from 'public/components/BookTickets/BookTicketsSheet';
import { track } from 'utils/analytics';

import HomepageImage from '../Image';

import './menu.less';

function goToSection(e, sectionId) {
  e.preventDefault();
  e.stopPropagation();

  const offset = 104;
  const element = document.getElementById(sectionId);
  const y = element.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({ top: y, behavior: 'instant' });
}

function MenuItem({ fields, isMobile }) {
  return (
    <a
      href={`#${fields.sectionId}`}
      onClick={(e) => {
        track('Click Home Nav Item', { label: fields.label });
        goToSection(e, fields.sectionId);
      }}>
      <HomepageImage field={fields.logo} />
      <span>{isMobile ? fields.label.split(' ')[0] : fields.label}</span>
    </a>
  );
}

function Mobile({ items, setActive }) {
  const midpoint = Math.ceil(items.length / 2);
  const firstHalf = items.slice(0, midpoint);
  const secondHalf = items.slice(-midpoint);

  return (
    <>
      {firstHalf.map(({ fields, sys }) => (
        <MenuItem key={sys.id} fields={fields} isMobile />
      ))}
      <button onClick={() => setActive(true)}>Book Tickets</button>
      {secondHalf.map(({ fields, sys }) => (
        <MenuItem key={sys.id} fields={fields} isMobile />
      ))}
    </>
  );
}

export default function Menu({ items }) {
  const classNames = useClassName('NewHomepageMenu');
  const [menuContainer] = useDOMElement('.navigation-header__menu-container');
  const scrollDirection = useScrollDirection();
  const { isMobile, isTablet } = useWindowSize();
  const [active, setActive] = useState(false);

  if (!menuContainer) return null;
  return createPortal(
    <>
      <div
        className={classNames('container')}
        {...(scrollDirection === 'down' && {
          style: { height: 0, borderBottom: 'none', display: 'none' },
        })}>
        {isMobile || isTablet ? (
          <Mobile items={items} setActive={setActive} />
        ) : (
          items.map(({ fields, sys }) => (
            <MenuItem key={sys.id} fields={fields} isMobile={isMobile} />
          ))
        )}
      </div>
      <BookTicketsSheet isOpen={active} onClose={() => setActive(false)} />
    </>,
    isMobile || isTablet ? document.querySelector('body') : menuContainer
  );
}
